import { george, observer, pr, React, RouteComponentProps, theme, ui, debug } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { IchAppStore } from "./IchAppStore";
import { IchAppRoutes } from "./IchAppRoutes";

type IProps = RouteComponentProps<{}> & {
    store: IchAppStore;
};

@observer
export class IchAppSigning extends React.Component<IProps, {}> {
    render() {
        console.log("### signing");
        return (
            <SigningComponent
                useWebVersion
                pollingUrl={this.props.store.signingPollingUrl}
                authTransactionId={this.props.store.authTransactionId}
                content={
                    <>
                        <div style={{ padding: theme.MARGIN }}>
                            <george.SectionTitle style={{ marginTop: 0 }}>
                                {ui.__("common.summary")}
                            </george.SectionTitle>
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                            <george.ResponsiveSummaryElement label={ui.__("signing.action.label")}>
                                <pr.SigningLabel>
                                    {ui.__("ichApp.summary.action.description")}
                                </pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                            <george.ResponsiveSummaryElement label={ui.__("common.fees")}>
                                <pr.SigningLabel>{ui.__("common.freeOfCharge")}</pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                            <george.ResponsiveSummaryElement label={ui.__("common.approval")}>
                                <pr.SigningLabel>{ui.__("ichApp.summary.legal")}</pr.SigningLabel>
                            </george.ResponsiveSummaryElement>

                        </div>
                    </>

                }
                onError={async (response: ISigningResponse) => {
                    debug.log("### signing error", response);
                    this.props.store.resetAgreements();
                    pushRoute("/error");
                }}
                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    this.props.store.resetAgreements();
                    pushRoute(IchAppRoutes.SUCCESS);
                }}
                onRetry={async () => {
                    await this.props.store.postAuthorization();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ichApp/IchAppSigning.tsx